export default "__VITE_ASSET__4IkGQZMy__"